import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import { Field, Form, ErrorMessage, Formik } from 'formik';
import * as Yup from 'yup';

export default function CadastroAnuncianteForm3({ initialValues, onSubmit }) {

    // Validação com Yup
    const validationSchema = Yup.object().shape({
        email: Yup.string().email('E-mail inválido').required('Preencha o endereço de e-mail'),
        nomeResponsavel: Yup.string().required('Preencha o nome do responsável'),
        sobrenome: Yup.string(),
        cargo: Yup.string().required('Digite o seu cargo'),
        cpf: Yup.string().required('Digite o CPF'),
        telefoneResponsavel: Yup.string().required('Digite o telefone'),
    });

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
        >
            {({ handleChange, values }) => (
                <Form>
                    <Field
                        name="email"
                        as={TextField}
                        fullWidth
                        label="E-mail"
                        variant="outlined"
                        size="small"
                        onChange={handleChange}
                        value={values.email}
                        helperText={<ErrorMessage name="email" />}
                    />
                    <Field
                        name="nomeResponsavel"
                        as={TextField}
                        fullWidth
                        label="Nome do responsável"
                        variant="outlined"
                        size="small"
                        onChange={handleChange}
                        value={values.nomeResponsavel}
                        helperText={<ErrorMessage name="nomeResponsavel" />}
                    />
                    <Field
                        name="sobrenome"
                        as={TextField}
                        fullWidth
                        label="Sobrenome"
                        variant="outlined"
                        size="small"
                        onChange={handleChange}
                        value={values.sobrenome}
                        helperText={<ErrorMessage name="sobrenome" />}
                    />
                    <Field
                        name="cargo"
                        as={TextField}
                        fullWidth
                        label="Cargo"
                        variant="outlined"
                        size="small"
                        onChange={handleChange}
                        value={values.cargo}
                        helperText={<ErrorMessage name="cargo" />}
                    />
                    <Field
                        name="cpf"
                        as={TextField}
                        fullWidth
                        label="CPF"
                        variant="outlined"
                        size="small"
                        onChange={handleChange}
                        value={values.cpf}
                        helperText={<ErrorMessage name="cpf" />}
                    />
                    <Field
                        name="telefoneResponsavel"
                        as={TextField}
                        fullWidth
                        label="Telefone"
                        variant="outlined"
                        size="small"
                        onChange={handleChange}
                        value={values.telefoneResponsavel}
                        helperText={<ErrorMessage name="telefoneResponsavel" />}
                    />
                    <Button type="submit" color="primary" variant="contained">
                        Enviar
                    </Button>
                </Form>
            )}
        </Formik>
    );
}
